import { useMemo } from "react";
import { EventStatusType } from "src/models";
import Label from "./label";

type StatusLabelProps = {
  status: EventStatusType
}

export function EldDriverStatusLabel({ status }: StatusLabelProps) {
  return useMemo(() => {
    let labelColor: "info" | "success" | "default" = "info";
    let useCustomBackground = false;
    if (status === "Driving") {
      labelColor = "success"
    } if (status === "Sleeper" || status === "Off Duty") {
      useCustomBackground = true;
      labelColor = "default";
    }

    return <Label variant="filled" sx={{ background: useCustomBackground ? "#637381" : undefined }} color={labelColor}>{status}</Label>
  }, [status]);
}
